<template>
  <div class="social-media-container">
    <a
      v-if="instagram"
      :href="instagram"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src="../assets/instagram-logo.svg" alt="Instagram" />
      <span class=" text-dark">Síguenos en Instagram</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'SocialMedia',
  props: {
    instagram: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.social-media-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 10px;
  a, a:visited {
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    color: #fff;
    & > img {
      width: 30px;
      height: 30px;
    }
  }
}
</style>
